import firebase from 'firebase/app';
import 'firebase/firestore';
import axios from 'axios'
import { firebaseAuth, firebaseDb, firebaseStorage } from './init';
import { getBrowserInfo } from '../utils/browser'
import { toast } from 'react-toastify';

export const updateQuizStatus = async (categoryId, quizId, newStatus) => {
  const quizRef = firebaseDb
    .collection("categories")
    .doc(categoryId)
    .collection("Quizzes")
    .doc(quizId);

  try {
    await quizRef.update({ status: newStatus });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getCourses = async () => {
  const coursesRef = firebaseDb.collection("courses");
  const coursesSnapshot = await coursesRef.get();

  return coursesSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  })).sort((a, b) => a.name.localeCompare(b.name));
};

export const getSingleDocument = async (email) => {
  try {
    const userDoc = await firebaseDb.collection('users').doc(email.trim()).get()
    return userDoc.data()
  } catch (error) {
    console.log(error)
  }
}

export const getAttendanceByEmail = async (email) => {
  if (!email) return
  const q = firebaseDb.collection("attendance").where("userId", "==", email);
  const querySnapshot = await q.get();
  const attendanceDocs = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
  return attendanceDocs;
};

export const getAttendance = async (date) => {
  if (!date) return
  const q = firebaseDb.collection("attendance").where("attendanceDate", "==", date);
  const querySnapshot = await q.get();
  const docs = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
  // const attendanceDocs = [];
  // querySnapshot.forEach((doc) => {
  //   attendanceDocs.push({ id: doc.id, ...doc.data() });
  // });
  return docs;
};

export const getAllTimeAttendance = async () => {
  try {
    const q = firebaseDb.collection("attendance");
    const querySnapshot = await q.get();
    const docs = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return docs;
  } catch (error) {
    console.log(error);
  }
};

export const getStudents = async () => {
  const collectionRef = firebaseDb.collection('users');
  const q = collectionRef.where("studentId", "!=", null);

  const querySnapshot = await q.get();

  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

export const getStudentById = async (studentId) => {
  const collectionRef = firebaseDb.collection("users");
  const q = collectionRef.where("id", "==", studentId);
  const querySnapshot = await q.get();

  if (querySnapshot.empty) return null;

  const doc = querySnapshot.docs[0];
  return { id: doc.id, ...doc.data() };
};

export const getStudentsByCourse = async (courseId) => {
  const collectionRef = firebaseDb.collection('users');
  const q = collectionRef.where('courseIds', 'array-contains', courseId);

  const querySnapshot = await q.get();

  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
}

export const changeStudentCourse = (userId, courses) => {
  const userRef = firebaseDb.collection("users").doc(userId);
  let arrayOfCourseIds = courses.map(obj => obj.courseId);

  return userRef.update({
    courses: courses,
    courseIds: arrayOfCourseIds
  })

};

export const deleteSingleDoc = async (collectionName, docId) => {
  try {
    await deleteDoc(collectionName, docId);
  } catch (error) {
    console.log(error);
  }
};

export const updateAttendanceRecord = async (id, attendanceRecord) => {
  try {
    await firebaseDb.collection("attendance").doc(id).update(attendanceRecord);
  } catch (error) {
    console.log(error);
  }
};

export const setAttendanceRecord = async (attendanceRecord) => {
  const attendanceRef = firebaseDb.collection("attendance");
  const newAttendanceRef = attendanceRef.doc();
  await newAttendanceRef.set(attendanceRecord);
  return newAttendanceRef.id;
}
export const changeAdminPermission = (userId, permissions) => {
  const userRef = firebaseDb.collection("users").doc(userId);

  return userRef.update({
    permissions,
  });
};

export const addAdminActivity = async (data, locationData = {}) => {
  const browserName = getBrowserInfo();
  const osName = navigator.platform;
  try {
    // const reduxState = store.getState();
    const myData = locationData
    data.browserName = browserName;
    data.osName = osName;

    data.coordination = myData;

    // Assuming you've already initialized Firebase
    const db = firebaseDb

    const apiKey = 'fb1769030518da07dc4e3fe6a2aae15b';
    const apiToken = 'ATTA1a4555ac1beca91c652bf7f8314d333a3e6c1f4c7868cccbd76423a1f335b83e2B6B2789';
    const listId = '6481a84c28f624814e0920a9';

    // Set up the API URL
    const url = `https://api.trello.com/1/cards?key=${apiKey}&token=${apiToken}`;

    // Set up the request payload
    const payload = {
      name: data.activity,
      desc: `
      Activity: ${data.activity}
      AdminId: ${data.adminId}
      UserId: ${data.activityOnUser ?? "N/A"}
      Activity Type: ${data.type}
      Browser Name: ${data.browserName}
      Os Name: ${data.osName}
      Latitude: ${myData.lat ?? "N/A"} 
      Longitude: ${myData.long ?? "N/A"} 
      ${data.fromCourse
          ? `Transfer From : ${data.fromCourse.courseName} course  ${data.fromCourse.module ? data.fromCourse.module + " module" : ""
          }`
          : ""
        }
      ${data.toCourse
          ? `To ${data.toCourse.courseName} course ${data.toCourse.module ? data.toCourse.module + " module" : ""
          }`
          : ""
        } `,
      idLabels: ["6481a83c1afdaf2b058915b6"],
      idList: listId,
    };

    // Assuming you have a Firestore collection reference named 'activitiesRef'
    await firebaseDb.collection('adminActivities').add(data);
    // Make the API request using fetch or axios
    const res = await axios.post(url, payload);

    console.log("Activity Tracked");
  } catch (error) {
    console.log(error);
  }
};

export const checkIsAdmin = async (email) => {
  try {
    var usersRef = firebaseDb.collection("users");

    const user = await usersRef
      .where("isAdmin", "==", true)
      .where("email", "==", email)
      .get()
    return user.size
  } catch (error) {
    console.log(error)
  }
  // .then(function (querySnapshot) {
  //   return querySnapshot.size;
  // })
  // .catch(function (error) {
  //   console.error("Error getting documents: ", error);
  //   throw error;
  // });
}

export const getAttendanceFilterBy = async () => {
  const startOfWeek = new Date();
  startOfWeek.setHours(0, 0, 0, 0);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());

  const endOfWeek = new Date();
  endOfWeek.setHours(23, 59, 59, 999);
  endOfWeek.setDate(endOfWeek.getDate() + (6 - endOfWeek.getDay()));
  const attendanceRef = firebaseDb.collection("attendance");
  const q = attendanceRef
    .where("attendanceDate", ">=", startOfWeek.toISOString().split("T")[0])
    .where("attendanceDate", "<=", endOfWeek.toISOString().split("T")[0]);
  const querySnapshot = await q.get();

  const attendanceDocs = [];
  querySnapshot.forEach((doc) => {
    attendanceDocs.push({
      id: doc.id,
      ...doc.data(),
      startOfWeek: startOfWeek.toISOString().split("T")[0],
    });
  });
  if (attendanceDocs > 0) {
    return attendanceDocs;
  } else {
    attendanceDocs[0] = {
      startOfWeek: startOfWeek.toISOString().split("T")[0],
    };
    return attendanceDocs;
  }
};

export const getAttendanceFilterByMonth = async (val) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = val === "current" ? now.getMonth() : now.getMonth() - 1;

  const startOfMonth = new Date(year, month, 1).toISOString().substring(0, 10);
  const endOfMonth = new Date(year, month + 1, 0)
    .toISOString()
    .substring(0, 10);
  const attendanceRef = firebaseDb.collection("attendance");
  const q = attendanceRef
    .where("attendanceDate", ">=", startOfMonth)
    .where("attendanceDate", "<=", endOfMonth);
  const querySnapshot = await q.get();
  const attendanceDocs = [];
  querySnapshot.forEach((doc) => {
    attendanceDocs.push({ id: doc.id, ...doc.data() });
  });
  return attendanceDocs;
};

export const getAttendanceFilterByModule = async (startDate, endDate) => {
  const attendanceRef = firebaseDb.collection("attendance");
  const q = attendanceRef
    .where("attendanceDate", ">=", startDate.substring(0, 10))
    .where("attendanceDate", "<=", endDate.substring(0, 10));
  const querySnapshot = await q.get();
  const attendanceDocs = [];
  querySnapshot.forEach((doc) => {
    attendanceDocs.push({ id: doc.id, ...doc.data() });
  });
  return attendanceDocs;
};


export const login = async (email, password) => {
  try {
    const user = await firebaseAuth.signInWithEmailAndPassword(email, password)
    return await getSingleDocument(user.user?.email?.trim())
  } catch (error) {
    throw {
      error: error.message
    }
  }
}
export const sendPasswordResetEmail = async (email) => {
  const url = new URL(window.location.href);
  const urlOrigin = url?.origin;
  const actionCodeSettings = {
    url: `${urlOrigin}?email=${encodeURIComponent(email)}`,
    handleCodeInApp: true
  };
  try {
    if (!email) return;
    await firebase.auth().sendPasswordResetEmail(email.toLowerCase(), actionCodeSettings);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const verifyResetCode = async (oobCode, expectedEmail) => {
  try {
    if (!oobCode) return;
    const email = await firebase.auth().verifyPasswordResetCode(oobCode);
    if (email !== expectedEmail) {
      throw new Error("This reset code does not belong to the provided email.");
    }
  } catch (error) {
    throw new Error(error.message);
  }
}

export const resetPassword = async (oobCode, newPassword) => {
  try {
    if (!oobCode || !newPassword) return;
    await firebase.auth().confirmPasswordReset(oobCode, newPassword);
  } catch (error) {
    throw new Error(error.message);
  }
}

export const getBugsAndActivities = async () => {
  try {
    const [bugsSnapshot, adminSnapshot, studentSnapshot] = await Promise.all([
      firebaseDb.collection('crashErrors').orderBy('createdAt', 'desc').limit(5).get(),
      firebaseDb.collection('adminActivities').orderBy('createdAt', 'desc').limit(5).get(),
      firebaseDb.collection('studentActivities').orderBy('createdAt', 'desc').limit(5).get(),
    ]);

    const bugs = bugsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const adminActivities = adminSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const studentActivities = studentSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    return {
      bugs,
      adminActivities,
      studentActivities,
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    return { bugs: [], adminActivities: [], studentActivities: [] };
  }
};

export const fetchBugs = async () => {
  try {
    const reports = await firebaseDb.collection('crashErrors').orderBy('createdAt', 'desc').limit(50).get()
    const reportedBugs = reports.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return {
      bugs: reportedBugs,
      lastDoc: reports.docs[reports.docs.length - 1]
    }
  } catch (error) {
    console.log(error)
  }
}

export const fetchNextBugs = async (doc) => {
  try {
    const reports = await firebaseDb.collection('crashErrors').orderBy('createdAt', 'desc').startAfter(doc).limit(50).get()
    const reportedBugs = reports.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return {
      bugs: reportedBugs,
      lastDoc: reports.docs[reports.docs.length - 1]
    }
  } catch (error) {
    console.log(error)
  }
}

export const fetchAdminActivities = async () => {
  try {
    const activities = await firebaseDb.collection('adminActivities').orderBy('createdAt', 'desc').limit(50).get()
    const adminActivites = activities.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return {
      activities: adminActivites,
      lastDoc: activities.docs[activities.docs.length - 1]
    }
  } catch (error) {
    console.log(error)
  }
}

export const fetchNextAdminActivities = async (doc) => {
  try {
    const activities = await firebaseDb.collection('adminActivities').orderBy('createdAt', 'desc').startAfter(doc).limit(50).get()
    const adminActivites = activities.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return {
      activities: adminActivites,
      lastDoc: activities.docs[activities.docs.length - 1]
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateDoc = async (collectionName, id, data) => {
  try {
    await firebaseDb.collection(collectionName).doc(id).update(data)
  } catch (error) {
    console.log(error)
  }
}

export const addDoc = async (collectionName, data) => {
  try {
    await firebaseDb.collection(collectionName).add(data)
  } catch (error) {
    console.log(error)
  }
}

export const deleteDoc = async (collectionName, id) => {
  try {
    await firebaseDb.collection(collectionName).doc(id).delete()
  } catch (error) {
    console.log(error)
  }
}

export const fetchStudentActivities = async () => {
  try {
    const studentActivties = await firebaseDb.collection('studentActivities').orderBy('createdAt', 'desc').get()
    const documents = studentActivties.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return documents
  } catch (error) {
    console.log(error)
  }
}

export const fetchCourses = async () => {
  try {
    const courseActivities = await firebaseDb.collection('courses').get()
    const documents = courseActivities.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return documents
  } catch (error) {
    console.log(error)
  }
}

export const fetchGeneralPaymentDetails = async () => {
  try {
    const doc = await firebaseDb.collection('generalInfo').doc('dy89z5Veirs4IoclGrUI').get()
    return doc.data()
  } catch (error) {
    console.log(error)
  }
}

export const uploadImageToFirebase = (image, imagePath) => {
  const imageName = image?.name ? image.name : `${Date.now()}.png`.toString()

  return new Promise((resolve) => {
    const path = firebaseStorage.ref(`${imagePath}/` + imageName);

    if (!image?.name) {
      path.putString(image, 'data_url')
        .then(() => path.getDownloadURL())
        .then((url) => resolve(url))
    } else {
      path.put(image)
        .then(() => path.getDownloadURL())
        .then((url) => resolve(url))
    }
  });
};

export const fetchCategories = async () => {
  try {
    const categorySnapshot = await firebaseDb.collection("categories").get();
    const categories = [];

    categorySnapshot.forEach((categoryDoc) => {
      if (categoryDoc.exists) {
        const categoryData = categoryDoc.data();
        const category = {
          id: categoryDoc.id,
          key: categoryDoc.id,
          quizName: categoryData.name,
          quizModule: categoryData.module,
          quizzes: [],
        };
        categories.push(category);
      }
    });

    const fetchQuizzesPromises = categories.map(async (category) => {
      const quizSnapshot = await firebaseDb
        .collection("categories")
        .doc(category.id)
        .collection("Quizzes")
        .get();

      quizSnapshot.forEach((quizDoc) => {
        if (quizDoc.exists) {
          const quizData = quizDoc.data();
          const quiz = {
            id: quizDoc.id,
            key: quizDoc.id,
            ...quizData,
          };
          category.quizzes.push(quiz);
        }
      });

      return category;
    });

    const updatedCategories = await Promise.all(fetchQuizzesPromises);

    return updatedCategories;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchQuizQuestions = async (categoryId, quizId) => {
  try {
    console.log("categoryId", categoryId)
    console.log('quizId', quizId)
    const quizSnapshot = await firebaseDb
      .collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .doc(quizId)
      .get();
    console.log(quizSnapshot.data())
    return quizSnapshot.data()
  } catch (error) {
    console.log(error)
  }
}

export const uploadImage = (image, imagePath) => {
  const imageName = image?.name ? image.name : `${Date.now()}.png`.toString()

  return new Promise((resolve) => {
    const path = firebaseStorage.ref(`${imagePath}/` + imageName);

    if (!image?.name) {
      path.putString(image, 'data_url')
        .then(() => path.getDownloadURL())
        .then((url) => resolve(url))
        .catch((error) => {
          console.log(error);
        });
    } else {
      path.put(image)
        .then(() => path.getDownloadURL())
        .then((url) => resolve(url))
        .catch((error) => {
          console.log(error);
        });
    }
  });
};

export const uploadCertificateImage = async (dataURL, courseName, email) => {
  try {
    const encodedEmail = encodeURIComponent(email);
    const imagePath = `certificates/${courseName}/${encodedEmail}.png`;
    const imageRef = firebaseStorage.ref(imagePath);

    await imageRef.putString(dataURL, 'data_url');
    const downloadURL = await imageRef.getDownloadURL();
    return downloadURL;

  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

export const deleteCertificateImage = async (courseName, email) => {
  let imagePath = `certificates/${courseName}/${email}.png`;
  if (email.includes("@")) {
    imagePath = `certificates/${courseName}/${encodeURIComponent(email)}.png`;
  }
  try {
    const imageRef = firebaseStorage.ref(imagePath);

    await imageRef.delete();
    return true;

  } catch (error) {
    console.error("Error deleting image:", imagePath, error);
    return false;
  }
};

export const saveCertificateInfo = async (studentId, certificateData) => {
  try {
    const collectionRef = firebaseDb.collection("users");
    const q = collectionRef.where("id", "==", studentId);
    const querySnapshot = await q.get();

    if (querySnapshot.empty) {
      console.error(`No user found with ID: ${studentId}`);
      return;
    }

    const doc = querySnapshot.docs[0];
    const userRef = collectionRef.doc(doc.id);

    const { courses } = doc.data();

    const updatedCoursesData = courses?.map((course) => {
      if (course.courseId === certificateData.courseId) {
        return {
          ...course,
          certificate: {
            url: certificateData.url,
            generatedAt: new Date().toISOString(),
          },
        }
      }
      return course;
    });

    await userRef.update({ courses: updatedCoursesData });
    return updatedCoursesData;
  } catch (error) {
    console.error(`Error updating certificate info for studentId: ${studentId}`, error);
  }
};

export const deleteCertificateInfo = async (studentId, courseId) => {
  try {
    const collectionRef = firebaseDb.collection("users");
    const q = collectionRef.where("id", "==", studentId);
    const querySnapshot = await q.get();

    if (querySnapshot.empty) {
      console.error(`No user found with ID: ${studentId}`);
      return;
    }

    const doc = querySnapshot.docs[0];
    const userRef = collectionRef.doc(doc.id);
    const { courses } = doc.data();

    const updatedCoursesData = courses.map((course) => {
      if (course.courseId === courseId) {
        const { certificate, ...rest } = course;
        return rest;
      }
      return course;
    });

    await userRef.update({ courses: updatedCoursesData });
    return updatedCoursesData;
  } catch (error) {
    console.error(`Error deleting certificate info for studentId: ${studentId}`, error);
  }
};

export const updateQuestion = (allQuestion, categoryId, quizId) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .doc(quizId)
      .update({
        questions: allQuestion,
      });
    resolve();
  });
};

export const addQuestion = (allQuestion, categoryId, quizId) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .doc(quizId)
      .update({
        questions: allQuestion,
      });
    resolve();
  });
};

export const addQuizData = (
  categoryId,
  data
) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .add(data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log(error.message);
      });
  });
};

export const updateQuizCategory = (data, categoryId, quizId) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .doc(quizId)
      .update(data);
    resolve();
  });
};
export const deleteQuizCategory = (categoryId, quizId) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .doc(categoryId)
      .collection("Quizzes")
      .doc(quizId)
      .delete()
    resolve();
  });
};

export const editCatgory = async (categoryId, data) => {
  if (!categoryId) return;
  try {
    const docRef = firebaseDb
      .collection("categories")
      .doc(categoryId);
    await docRef.update({
      name: data.name,
      module: data.module,
    });
  } catch (error) {
    console.log(error);
  }
};

export const deleteCatgory = async (categoryId) => {
  if (!categoryId) return;
  try {
    const docRef = firebaseDb
      .collection("categories")
      .doc(categoryId);
    await docRef.delete();
  } catch (error) {
    console.log(error);

  }
};

export const addCategories = (category, description) => {
  return new Promise((resolve, reject) => {
    firebaseDb.collection("categories")
      .add({
        name: category,
        createdAt: Date.now(),
        module: description,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        console.log(error);
      });
  });
};

export const userUpdate = async (email, params) => {
  try {
    await firebaseDb.collection("users").doc(email.toLowerCase()).update(params);
  } catch (error) {
    console.log(error.message);
  }
};

export const fetchAdmins = async () => {
  const collectionRef = firebaseDb.collection("users");

  const query = collectionRef.where("isAdmin", "==", true);

  const querySnapshot = await query.get();

  const userDocs = [];
  querySnapshot.forEach((doc) => {
    if (!doc.data().isSuperAdmin) {
      userDocs.push({ id: doc.id, ...doc.data() });
    }
  });

  return userDocs;
};
